export default "__VITE_ASSET__CRcjsibC__"